import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ConfirmAction } from 'components';
import { useDeleteDocumentMutation } from 'app/services/workers';
import { WorkerDocument } from 'app/types/worker';
import { documentTypeName } from 'utils/worker';

const DeleteDocument = ({ document }: { document: WorkerDocument }) => {
  const { t } = useTranslation();
  const [ deleteDocument, meta ] = useDeleteDocumentMutation();

  const typeName = documentTypeName({ Code: document.DocumentTypeCode, Name: document.DocumentTypeName }) || t('entities.workerdocument.title');
  const label = `${typeName}${document.FileName ? ` (${document.FileName})` : ''}`;

  return <ConfirmAction
    callback={() => deleteDocument(document.Id).unwrap()}
    successMessage={t('common.deletesuccess', { content: label })}
    confirmMessage={t('common.deleteconfirm', { content: label })}
    meta={meta}
    tooltipButtonProps={{
      title: t('common.delete'),
      minimized: true,
      buttonProps: {
        danger: true,
        type: 'link',
        icon: <DeleteOutlined />,
      }
    }}
  />;
};

export default DeleteDocument;
